import { render, staticRenderFns } from "./Samyoga2025ListaItem.vue?vue&type=template&id=2e57f140&"
import script from "./Samyoga2025ListaItem.vue?vue&type=script&lang=js&"
export * from "./Samyoga2025ListaItem.vue?vue&type=script&lang=js&"
import style0 from "./Samyoga2025ListaItem.vue?vue&type=style&index=0&id=2e57f140&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports